var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/imgs/teacher/operation.png"),"alt":""}}),_c('img',{attrs:{"src":require("../assets/imgs/teacher/publication.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }